import { EventBus } from "../../../eventbus";

export default {
  props: {
    xl: Boolean,
  },
  data() {
    return {
      id: this.$options.name,
      show: false,
      activeId: "",
      activeFormData: {},
    };
  },
  created() {
    EventBus.$on(`closeallactions`, () => {
      this.reset();
    });

    EventBus.$on(`${this.id}-show`, (data) => {
      this.show = true;
      this.activeId = data.id;
      this.activeFormData = data.data;
    });

    EventBus.$on(`${this.id}-close`, () => {
      this.close();
    });
  },
  methods: {
    reset() {
      this.show = false;
      this.activeId = "";
      this.activeFormData = {};
    },
    close() {
      if (this.show) {
        this.reset();

        //reset url
        if (this.$route.params.file) {
          if (this.$route.path.includes("collection")) {
            this.$router.push(
              `/${this.$store.state.company}/collection/expanded/${this.$route.params.id}`
            );
          } else if (this.$route.path.includes("search")) {
            this.$router.push(
              `/${this.$store.state.company}/search/${this.$route.params.query}`
            );
          } else {
            const mySpace = window.location.href.includes("myspace");
            this.$router.push(
              `/${this.$store.state.company}/${
                mySpace ? "myspace" : "home"
              }/expanded/${this.$route.params.id}`
            );
          }
        }

        EventBus.$emit(`closeallactions`, this.close);
      }
    },
  },
  watch: {
    activeId() {},
    activeFormData() {},
  },
};
